import {AfterViewInit, Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {fromEvent, Observable, Subject, Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged, finalize, tap} from 'rxjs/operators';
import {FilteredModel} from '../../models/filteredModel';
import {ScreeningLight} from '../../models/screeningInvite';
import {GroupApplicantsService} from '../../services/group-applicants.service';
import {GroupApplicantsModel} from '../../models/groupApplicantsModel';
import {ToastrService} from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-group-applicant',
  templateUrl: './group-applicant.component.html',
  styleUrls: ['./group-applicant.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class GroupApplicantComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() public screeningLight: ScreeningLight;

  public formDataLoading = false;
  public savingData = false;
  public filteredScreenings: FilteredModel[] = [];
  public loadingData: boolean;
  public message: string;
  public messageStatus: string;
  public showMessage: boolean;

  private filterChange = new Subject<any>();
  private filterObs = new Subscription();

  public filterValue: string;

  @ViewChild('filterValue', {static: false}) filter: ElementRef;

  public filterOptions: FilterdOptions[] = [
    {value: 'name', label: 'Name'},
    {value: 'ssn', label: 'SSN'},
    {value: 'reportNumber', label: 'Report #'}
  ];

  public filterOption: FilterdOptions;

  constructor(
    public modalRef: NgbModal,
    private readonly groupApplicantsService: GroupApplicantsService,
    private readonly  toast: ToastrService
  ) {

    
  }
  ngOnDestroy(): void {
    if(this.filterObs) this.filterObs.unsubscribe();
  }

  public ngOnInit(): void {
    this.formDataLoading = false;
    this.filterOption = this.filterOptions[0];
  }

  public ngAfterViewInit(): void {

    this.filterObs = this.filterChange
      .pipe(debounceTime(350))
      .subscribe(() => {
        console.log("filt change, loading apps")
        this.filteredScreenings = [];
        this.loadScreenings();
      });
  }

  public loadScreenings(): void {
    if (!this.filterValue) {
      this.filteredScreenings = [];
      return;
    }

    this.loadingData = true;

    // tslint:disable-next-line:max-line-length
    this.groupApplicantsService.getScreeningsForGroupList(this.screeningLight.locationId, 25, this.filterOption.value, this.filterValue).subscribe((r: FilteredModel[]) => {
      this.filteredScreenings = r;
      this.loadingData = false;
    });
  }

  public submit(): void {

    this.showMessage = false;
    this.message = '';
    this.messageStatus = '';

    const s = new GroupApplicantsModel();
    s.GroupOrderId = this.screeningLight.invitationId;

    const filteredData = this.filteredScreenings.filter((e: FilteredModel) => e.selected);

    filteredData.forEach((e: FilteredModel) => {
      s.InvitationIds.push(e.reportNumber);
    });

    if (s.InvitationIds.length < 1) {
      this.message = 'No users have been selected';
      this.showMessage = true;
      this.messageStatus = 'warning';
      return;
    }

    this.savingData = true;
    this.groupApplicantsService.groupApplicants(s).pipe(finalize(() => {
      this.savingData = false;
    })).subscribe((resp: any) => {
      if (!resp || !resp.success) {
        this.message = 'Unable to group applicants';
        this.showMessage = true;
        this.messageStatus = 'error';

        this.toast.error(this.message, this.message);

        return;
      }

      this.message = 'Applicants grouped successfully';
      this.toast.success(this.message, this.message);
      this.close();

    });
  }

  public cancel(): void {
    this.close();
  }

  public close(): void {
    this.modalRef.dismissAll();
  }

  public filterChanged(e: any): void {
    console.log('FILTER CHANGED: ', this.filterValue);
    this.filterChange.next();
  }

}

export interface FilterdOptions {
  value: string;
  label: string;
}

